// tenant.ts
import tenants from './tenants.json';

export const getTenantConfig = () => {
  const id = process.env.REACT_APP_TENANT_ID??"demo";
  const config = tenants[id];
  if (!config) throw new Error(`Tenant config not found for ID: ${id}`);
  return { id, ...config };
};